import PropTypes from "prop-types";
import React from "react";

export const Success = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path d="M14.6,26l-7.7-7.7l2.8-2.8l4.9,4.8l11-11l2.9,2.9L14.6,26z M17.5,0C12.9,0,8.8,1.7,5.7,4.6 C2.2,7.8,0,12.4,0,17.5C0,27.2,7.8,35,17.5,35c5.1,0,9.7-2.2,12.9-5.7C33.3,26.2,35,22,35,17.5C34.9,7.8,27.1,0,17.5,0" />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "0 0 34.9 34.9",
    };
  }
};

Success.displayName = "SuccessIcon";

Success.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /**
   * custom allows for component to implement styling for a specific characteristic. There is no obligation for a
   * component to implement the custom prop.
   */
  custom: PropTypes.object,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Success.defaultProps = {
  role: "img",
};
